import { render, staticRenderFns } from "./PatientFilterBox.vue?vue&type=template&id=1309e77a&scoped=true"
import script from "./PatientFilterBox.vue?vue&type=script&lang=js"
export * from "./PatientFilterBox.vue?vue&type=script&lang=js"
import style0 from "./PatientFilterBox.vue?vue&type=style&index=0&id=1309e77a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1309e77a",
  null
  
)

export default component.exports